import { useEffect, useState } from 'react'

/**
 * Whole seconds since `from`, ticking while `running`. Counted from the
 * request's own timestamp, so a reload keeps counting from the truth rather
 * than from this mount.
 */
export function useElapsed(from: number | undefined, running: boolean): number {
  const [now, setNow] = useState(() => Date.now())
  useEffect(() => {
    if (!running) return
    setNow(Date.now())
    const id = window.setInterval(() => setNow(Date.now()), 1000)
    return () => window.clearInterval(id)
  }, [running])
  return running && from ? Math.max(0, Math.floor((now - from) / 1000)) : 0
}

/** Whole seconds a game (or a version of it) has been in the making, counted from its request. */
export function useMakingElapsed(artifact: any, running: boolean): number {
  return useElapsed(artifact?.generation?.requestedAt ?? artifact?.createdAt, running)
}
